export default {
  descriptionColor: '',
  headingTextTransform: 'capitalize',
};
